import { Monitor, Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { SidebarMenuButton, SidebarMenuItem, useSidebar } from "@/components/ui/sidebar";

const OPTIONS = [
  { value: "light", label: "Lys", icon: Sun },
  { value: "dark", label: "Mørk", icon: Moon },
  { value: "system", label: "Automatisk", icon: Monitor },
] as const;

// Stored per device, not per user: on a shared bridge PC the right theme
// depends on the lighting at the screen, not on who is logged in.
export function ThemeMenuItem() {
  const { theme, setTheme } = useTheme();
  const { isMobile } = useSidebar();
  const current = OPTIONS.find((o) => o.value === theme) ?? OPTIONS[0];
  const Icon = current.icon;

  return (
    <SidebarMenuItem data-component="ThemeMenuItem">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <SidebarMenuButton
            id="sidebar-theme-trigger"
            tooltip={`Utseende: ${current.label}`}
            aria-label={`Utseende: ${current.label}`}
          >
            <Icon className="h-4 w-4" />
            <span>Utseende</span>
            <span className="ml-auto text-muted-foreground text-xs">{current.label}</span>
          </SidebarMenuButton>
        </DropdownMenuTrigger>
        <DropdownMenuContent id="sidebar-theme-menu" side={isMobile ? "top" : "right"} align="end" className="w-52">
          <DropdownMenuLabel>Utseende</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuRadioGroup value={current.value} onValueChange={setTheme}>
            {OPTIONS.map(({ value, label, icon: OptionIcon }) => (
              <DropdownMenuRadioItem key={value} id={`theme-option-${value}`} value={value} className="py-2">
                <OptionIcon className="mr-2 h-4 w-4" />
                <span className="flex flex-col">
                  {label}
                  {value === "system" && (
                    <span className="text-muted-foreground text-xs">Følger enhetens innstilling</span>
                  )}
                </span>
              </DropdownMenuRadioItem>
            ))}
          </DropdownMenuRadioGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </SidebarMenuItem>
  );
}
